import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AddLayerButton from './AddLayerButton';
import MenuDrawer from '../MenuDrawer';
import Stats from './Stats';
import Status from './Status';
import Stackup from '../../../common/Stackup';
import Scene from '../../../common/Scene';
import { floor } from '../../../../lib/stackup';
import { position as positionPropType } from '../../../../prop-types/sizeMe';
import { stackupLayerPropType } from '../../../../lib/shapes';

export class StackupEditorComponent extends Component {
  constructor(props){
    super(props);
    this.state = {
      clickedLayer: undefined,
      drawerOpen: false,
      freezeMouseEvents: false,
    };
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
  }

  handleDrawerClose() {
    this.setState({
       drawerOpen: false,
       clickedLayer: undefined,
       freezeMouseEvents: false,
    });
  }

  handleDrawerOpen(target) {
    this.setState({
       drawerOpen: true,
       clickedLayer: target,
       freezeMouseEvents: true,
    });
  }

  render() {
    const {
      classes,
      layers,
      width,
      height,
      position,
      setHoveredLayer,
      unSetHoveredLayer
    } = this.props;
    const { drawerOpen, clickedLayer, freezeMouseEvents } = this.state;
    const floorY = floor(layers);

    return (
      <div className={classes.root}>
        <Scene
          axisHelper
          autoRender
          floor={floorY}
          width={width}
          height={height}
        >
          <Stackup
            layers={layers}
            onLayerClicked={this.handleDrawerOpen}
            setHoveredLayer={setHoveredLayer}
            unSetHoveredLayer={unSetHoveredLayer}
            freezeMouseEvents={freezeMouseEvents}
          />
        </Scene>
        <Status position={position} />
        {process.env.NODE_ENV === 'development' &&
          <Stats position={position} />}
        <AddLayerButton />
        <MenuDrawer
          open={drawerOpen}
          target={clickedLayer}
          onClose={this.handleDrawerClose}
        />
      </div>
    );
  }
}

StackupEditorComponent.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired
  }).isRequired,
  setHoveredLayer: PropTypes.func,
  unSetHoveredLayer: PropTypes.func,
  position: positionPropType.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  layers: PropTypes.arrayOf(PropTypes.shape(stackupLayerPropType)).isRequired,
};

StackupEditorComponent.defaultProps = {
  setHoveredLayer: null,
  unSetHoveredLayer: null
}

export default StackupEditorComponent;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/StackupEditor/StackupEditorComponent.js